import { render, staticRenderFns } from "./longpreepop.vue?vue&type=template&id=55962fcd&scoped=true"
import script from "./longpreepop.vue?vue&type=script&lang=js"
export * from "./longpreepop.vue?vue&type=script&lang=js"
import style0 from "./longpreepop.vue?vue&type=style&index=0&id=55962fcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55962fcd",
  null
  
)

export default component.exports